import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnInit, OnDestroy } from '@angular/core';

import { ModalService } from 'app/shared/modal/modal.service';
import { CapitalizePipe } from 'app/shared/capitalize.pipe';
import { VestibularService } from 'app/vestibular/shared/vestibular.service';
import { CursosService } from 'app/graduacao/cursos/shared/cursos.service';

import { Curso } from 'models/curso';
import { DadosVestibular } from 'models/dados-vestibular';
import PolosMock from 'mocks/vestibular/polos.json';
import { OpcaoCurso } from 'models/vestibular';
import { environment } from '../../../../../environments/environment';
import { Observable, Subject } from 'rxjs';

/**
 * @todo refatorar em componentes menores
 */

@Component({
  selector: 'selecao-curso',
  templateUrl: './selecao-curso.component.html',
  styleUrls: ['./selecao-curso.component.scss'],
})
export class SelecaoCursoComponent implements OnChanges, OnInit, OnDestroy {

  @Input() labelSaveButton = 'Próximo';
  @Input() responsive = true;
  @Input() titulo = `O que você gostaria de estudar?`;
  @Input() dadosVestibular: DadosVestibular;
  @Input() cursoSelecionado: any;

  @Output() onSave: EventEmitter<any> = new EventEmitter();

  loading = false;
  environment = environment;
  opcoesPolos: any[] = [];
  opcoesCursos: Curso[] = [];
  opcoesCidades: any[] = [];
  opcoesCampusTurno: any[] = [];
  legendasDescontos: any[] = [];

  polo: any = '';
  integral = false;
  auxCampusTurno: any = {};
  curso: any = '';
  cursoIdParam = '';
  cidade: any = '';
  campusTurno: any = undefined;
  campusTurnoSelecionado: any = undefined;
  opcoes:any;

  marketPlaceData:any;

  private onDestroy = new Subject<void>();

  confCapitalize = {
    todasPalavras: true,
    forcarCaixaBaixa: ['em', 'da', 'de', 'di', 'do', 'du', 'dos', 'das', 'e', 'a'],
  };
  private capitalizePipe = new CapitalizePipe();

  constructor(
    private modalService: ModalService,
    private vestibularService: VestibularService,
    private cursosService: CursosService,
  ) {}


  ngOnDestroy(): void {
      this.onDestroy.next();
  }

  ngOnInit(): void {
    if(sessionStorage.getItem("marketPlaceData") != null){
      Observable.timer(1000, 3000).takeUntil(this.onDestroy).subscribe(() =>{
        this.save();
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const { dadosVestibular, cursoSelecionado } = changes;

    if (dadosVestibular && dadosVestibular.currentValue) {
      this.dadosVestibular = dadosVestibular.currentValue;
      this.loading = true;
      this.loadOpcoesCurso();
    }

    if (cursoSelecionado && cursoSelecionado.currentValue) {
      this.cursoSelecionado = cursoSelecionado.currentValue;
      this.loadDadosVestibular();
    }

  }

  save() {
    const value = {
      curso: this.curso,
      cidade: this.cidade,
      campusTurno: this.campusTurno,
      auxCampusTurno: this.auxCampusTurno,
      polo: this.polo,
    }

    //console.log(value);

    this.onSave.emit({
      curso: this.curso,
      cidade: this.cidade,
      campusTurno: this.campusTurno,
      auxCampusTurno: this.auxCampusTurno,
      polo: this.polo,
    });
  }

  private loadOpcoesCurso() {
    // buscar opcoes curso, esses dados vao restringir
    // quais cursos / campi / turno podem ser escolhidos nesse vestibular
    if (this.dadosVestibular && this.dadosVestibular.vestibular && this.dadosVestibular.vestibular.id) {
      this.vestibularService.getOpcoesCursos(this.dadosVestibular.vestibular.id.ano, this.dadosVestibular.vestibular.id.codigo)
        .then((opcoes: OpcaoCurso[]) => {
          // montar array de ids de cursos
          this.opcoes = opcoes;

          let ids: string[] = [];

          if (this.dadosVestibular.vestibular.cursosOfertados) {
            for (const curso of this.dadosVestibular.vestibular.cursosOfertados) {
              ids.push(curso.codCurso);
            }
          }

          for (const curso of opcoes) {
            ids.push(curso.id);
          }

          // retirar duplicados
          ids = ids.sort().filter(function (item, pos, arr) {
            return !pos || item !== arr[pos - 1];
          });

          //console.log(ids);
          this.cursosService.getCurso(ids, { porPagina: 100 }).then(
            (cursosOutput: Curso[]) => {
              this.opcoesCursos = this.intersectOpcoesCursos(opcoes, cursosOutput);
              //console.log(this.opcoesCursos);
              //console.log(ids);
              // ordenação por nome
              this.opcoesCursos = this.opcoesCursos.sort((a, b) =>
                a.nome > b.nome ? 1 : -1,
              );

              let nomeRepetidoAux = { nome: '', index: -1 };
              //console.log(this.opcoesCursos);
              this.opcoesCursos = this.opcoesCursos.map((curso, index) => {
                curso.campus = this.replicarCampiPorTurnos(curso.campus);
                if (curso.nome === nomeRepetidoAux.nome) {
                  if (nomeRepetidoAux.index >= 0) {
                    this.opcoesCursos[nomeRepetidoAux.index].gerarNomeFormatado();
                  }
                  curso.gerarNomeFormatado();
                }
                nomeRepetidoAux = { nome: curso.nome, index: index };
                return curso;
              });

              if (this.dadosVestibular.vestibular.indicacaoEad === 'S') {
                this.initOpcoesPolos();
              }

              if (this.cursoIdParam) {
                this.curso = this.opcoesCursos.find(curso => curso.id === this.cursoIdParam);
                this.onChangeCurso();
              } else if (this.opcoesCursos.length === 1) {
                // esse vestibular só tem um curso, então já vem selecionado
                this.curso = this.opcoesCursos[0];
                this.onChangeCurso();
              }

              //-------------------------------- ALTERAÇÕES IMPLEMENTAS PARA O MARKET-PLACE DA UFMA -------------------

              this.getMarketPlaceData();
              if(this.marketPlaceData != null){
                this.opcoesCursos.forEach((curso) =>{
                  if(this.marketPlaceData['curso']['id'] == curso['id']){
                    this.curso = curso;
                    this.onChangeCurso();
                  }
                });
              }
              if(this.marketPlaceData == null){
              this.loading = false;
              }
            });
        });
    }else{
      console.log('VESTIBULAR INSCRIÇÕES ENCERRADAS');
    }
  }

  private loadDadosVestibular() {
    if (this.cursoSelecionado) {
      if (this.dadosVestibular.vestibular.indicacaoEad === 'S') {
        this.polo = this.dadosVestibular.cursoSelecionado.polo;
        this.onChangePolo();
      }
      this.curso = this.dadosVestibular.cursoSelecionado.curso;
      this.onChangeCurso();
      if (this.dadosVestibular.vestibular.indicacaoEad !== 'S') {
        this.cidade = this.dadosVestibular.cursoSelecionado.cidade;
        this.onChangeCidade();
      }
      this.campusTurno = this.dadosVestibular.cursoSelecionado.campusTurno;
      this.auxCampusTurno = this.dadosVestibular.cursoSelecionado.auxCampusTurno;
      this.handleOptionChange();
    }
  }

  private replicarCampiPorTurnos(campi) {
    let tmpCampus = [];

    campi.forEach((campus) => {
      const campusTurno = campus.turnos.map(turno => ({ ...campus, turno }));
      tmpCampus = [...tmpCampus, ...campusTurno];
    });
    //console.log(tmpCampus);
    return tmpCampus;
  }

  private intersectOpcoesCursos(opcoesCursos: any, cursos: Curso[]): Curso[] {
    // retirar opcoes de cursos que nao estejam em opcoesCursos
    if (!opcoesCursos || opcoesCursos.length <= 0) {
      return cursos;
    }
    //console.log(opcoesCursos);
    //console.log(cursos);
    const cursosDisponiveis: Curso[] = [];

    for (const curso of cursos) {
      const opcaoCurso = opcoesCursos.find(opcao => opcao.id === curso.id);
      if (opcaoCurso) {
        if (curso.presencial === 'S') {
          let campusOfertados = [];
          for (const opcaoCampus of opcaoCurso.campi) {
            const campusFiltrados = curso.campus
              .filter(campusCurso => {
                const matchId = campusCurso.id === opcaoCampus.id;
                let turnos = [];
                opcaoCampus.turnos.forEach(element => {
                  turnos.push(element.turno);
                });
                const matchTurnos = campusCurso.turnos.some(turno => turnos.indexOf(turno) > -1);
                return matchId && matchTurnos;
              })
              .map(campusCurso => {
                let turnos = [];
                opcaoCampus.turnos.forEach(element => {
                  turnos.push(element.turno);
                });
                campusCurso.turnos = campusCurso.turnos.filter(turno => turnos.indexOf(turno) > -1);
                return campusCurso;
              });
              //console.log(campusOfertados);
            campusOfertados = [...campusOfertados, ...campusFiltrados];
          }
          curso.campus = campusOfertados;
          cursosDisponiveis.push(curso);
        } else {
          // Adiciona o curso, caso seja EAD
          //console.log(curso);
          const campusEad = curso.campus[0];
          curso.campus = opcaoCurso.campi.map(campus => ({ ...campusEad, ...campus }));
          cursosDisponiveis.push(curso);
        }
      }
    }
    return cursosDisponiveis;
  }

  isClickable(opcaoCampus: any, turno: string): boolean {
    return opcaoCampus[turno] !== null;
  }

  isSelected(opcaoCampus: any, turno: string): boolean {
    return this.auxCampusTurno.campus
      && this.auxCampusTurno.turno
      && this.auxCampusTurno.campus.id === opcaoCampus.id
      && this.auxCampusTurno.turno === turno;
  }

  handleOptionChange() {
    if (!this.curso || !this.auxCampusTurno) {
      return;
    }
    this.campusTurno = this.auxCampusTurno.campus[this.auxCampusTurno.turno];
  }

  getValorFinal(opcaoCampus: any, turno: string): number {
    if (opcaoCampus[turno] === null) {
      return null;
    }
    return this.calcValorFinal(this.curso, opcaoCampus[turno]);
  }

  calcValorFinal(curso, campusTurno): number {
    let preco = curso.valorBase;
    if (campusTurno.desconto) {
      preco *= (1 - (campusTurno.desconto / 100));
    }
    return preco;
  }

  getLegenda(opcaoCampus: any, turno: string): string {
    if (opcaoCampus[turno] === null) {
      return null;
    }
    return opcaoCampus[turno].legendaDesconto;
  }

  getLegendaDescontoSelecionada() {
    return !this.auxCampusTurno.campus ? undefined :
      this.auxCampusTurno.campus[this.auxCampusTurno.turno].legendaDesconto;
  }

  getAnoAtual() {
    return new Date().getFullYear();
  }

  mostrarModalCampusTurnoMobile(): void {
    if (this.cidade && this.curso) {
      this.modalService.open('campusTurnoMobile');
    }
  }

  onChangeCurso() {
    this.cidade = this.polo || '';
    this.auxCampusTurno = {};
    this.campusTurno = null;

    // Popula as opções de campus e turno caso seja EAD
    if (this.dadosVestibular.vestibular.indicacaoEad === 'S') {
      return this.initOpcoesCampusTurno();
    }
    // console.log(this.curso);
    // nova lista de cidades
    const cidades: any[] = [];
    const set: Set<number> = new Set([]);
    for (const campus of this.curso.campus) {
      if (!set.has(campus.idCidade)) {
        set.add(campus.idCidade);
        cidades.push({
          id: campus.idCidade,
          nome: campus.nomeCidade,
        });
      }
    }
    // ordenar por nome
    this.opcoesCidades = cidades.sort((a, b) =>
      a.nome > b.nome ? 1 : -1,
    );

    // esse curso só tem uma cidade, então já vem selecionada
    if (this.opcoesCidades.length === 1) {
      this.cidade = this.opcoesCidades[0];
      this.onChangeCidade();
    }
  }

  onChangePolo() {
    this.curso = '';
    this.auxCampusTurno = {};
    this.campusTurno = null;
    /*
    this.opcoesCursos = this.opcoesCursos
      .filter(opcaoCurso => opcaoCurso.campus
        .some(polo => this.opcoesPolos
          .findIndex(opcaoPolo => opcaoPolo.id === polo.id) >= 0,
        ),
      );
      */
    //console.log(this.opcoesCursos);

    //Verifica se o vestibular possui cursos híbridos
    /*
    let isHibrido = true;

    this.opcoesCursos.forEach((curso)=>{
      if(curso.presencial!=='H') isHibrido = false;
    });
    */
    //console.log(this.opcoesCursos);
    //console.log(this.polo);
    let cursosOfertados: any[] = [];
    this.opcoesCursos = [];
    this.opcoes.forEach((opcao)=>{
      // Precisamos agora pegar os polos e verificar se existe para o polo selecionado
      let isOfertado = false; // Verifica se o curso é ofertado para o polo selecionado

      opcao.campi.forEach((oferta)=>{
        if(oferta.id===this.polo.id) isOfertado = true;
      });
      if(isOfertado){
        this.opcoesCursos.push(opcao);
      }
    });
    //console.log(this.opcoesCursos);
    /*
    if(isHibrido){
      // Significa que temos que tirar os polos parnaíba e bacabal
      this.opcoesPolos = this.opcoesPolos.filter(item => item.id !== '18');
      this.opcoesPolos = this.opcoesPolos.filter(item => item.id !== '15');
    }
    */

    /**
     * Precisamos tirar o curso que não faz parte desse polo
     * O atributo para limitar é o "polo" em cursos-graduacao
     */
    /*
      console.log(this.polo);
    this.opcoesCursos.forEach((curso)=>{
      console.log(curso);
    });
    */
  }

  onChangeCidade() {
    this.auxCampusTurno = {};
    this.campusTurno = null;
    this.initOpcoesCampusTurno();
  }

  handleEventChange({ campusTurnoInfo, campusTurno }: any) {
    this.campusTurno = campusTurnoInfo;
    this.auxCampusTurno = campusTurno;
  }

  private initOpcoesCampusTurno() {
    // filtra somente campi dessa cidade
    let temp: any[] = [];

    if (this.dadosVestibular.vestibular.indicacaoEad === 'S') {
      if (this.polo.id === '100') {
        temp = this.polo.polos.filter(poloSecundario => this.curso.campus.findIndex(campusCurso => campusCurso.id === poloSecundario.id) !== -1);
      } else {
        temp = [...this.polo.polos];
      }
    } else {
      temp = this.curso.campus.filter(value => value.idCidade === this.cidade.id);
    }
    //console.log(temp);

    const map = new Map([]);
    const mapDescontos = new Map([]);
    let indexDescontos = 97;

    for (const campus of temp) {
      // montagem da lista de portarias para visualizacao dos descontos
      const txtDesconto = this.getTextoDesconto(campus);
      if (!mapDescontos.get(txtDesconto)) {
        const legenda = `(${String.fromCharCode(indexDescontos++)})`;
        campus.legendaDesconto = legenda;
        mapDescontos.set(txtDesconto, legenda);
      } else {
        campus.legendaDesconto = mapDescontos.get(txtDesconto);
      }

      // montagem das opcoes, juntando varios objetos compostos campus/turno
      // em um unico objeto campus com todas as opcoes de turno para aquele campus
      let objCampus = null;
      if (!map.get(campus.id)) {
        // nao existe no mapa
        objCampus = {
          id: campus.id,
          nome: campus.nome,
          integral: null,
          matutino: null,
          vespertino: null,
          noturno: null,
        };
        map.set(campus.id, objCampus);
      } else {
        // ja existe no mapa
        objCampus = map.get(campus.id);
      }
      this.setSwitchTipoTurno(objCampus, campus);
    }

    const opcoesCampus: any[] = [];
    map.forEach((value, key, m) => { opcoesCampus.push(value); });
    this.opcoesCampusTurno = opcoesCampus.sort((a, b) =>
      a.nome > b.nome ? 1 : -1,
    );
    //console.log(this.opcoesCampusTurno);

    const legendas: any[] = [];
    mapDescontos.forEach((value, key, m) => { legendas.push({ legenda: value, texto: key }); });
    this.legendasDescontos = legendas.sort((a, b) =>
      a.legenda > b.legenda ? 1 : -1,
    );
  }

  // TODO otimizar a complexidade computacional desse algoritmo
  private initOpcoesPolos() {
    //console.log(this.opcoesCursos);
    const polosEmCursos = this.opcoesCursos
      .map(opcaoCurso => opcaoCurso.campus)
      .reduce((prev, curr) => [...prev, ...curr])
      .filter((polo, index, opcoes) => opcoes.findIndex(currentPolo => currentPolo.id === polo.id) === index);
    const polosForaMock = polosEmCursos
      .filter(poloTemp => {
        return PolosMock.findIndex(polo => polo.id === poloTemp.id) === -1;
      });

    const bsbPolos = ['09', '10', '11'];
    polosForaMock.forEach(temp => {
      if (!bsbPolos.some(bsbPolo => bsbPolo === temp.id)) {
        PolosMock.push({
          'id': temp.id,
          'nome': this.capitalizePipe.transform(temp.nome.substring(5), this.confCapitalize),
          'polos': [{
            'id': temp.id,
            'nome': this.capitalizePipe.transform(temp.nome, this.confCapitalize),
            'turno': temp.turno,
            'turnos': temp.turnos,
          }],
        });
      }
    });

    this.opcoesPolos = PolosMock
      .filter(cidade => {
        // Trata o caso de Brasília, que possui 3 polos
        if (cidade.id === '100') {
          cidade.polos = cidade.polos.filter(polo => {
            return polosEmCursos.findIndex(poloCurso => poloCurso.id === polo.id) > -1;
          });
          return cidade.polos && cidade.polos.length;
        }
        // Trata o caso dos demais polos
        return polosEmCursos.findIndex(polo => polo.id === cidade.id) !== -1;
      })
      .map(cidade => {
        let polos;
        // Trata o caso de São Luís, onde existe mais de um polo de apoio na mesma cidade
        if (cidade.id === '13') {
          const poloSLZ = polosEmCursos.find(poloEmCurso => cidade.id === poloEmCurso.id);
          polos = cidade.polos.map(polo => ({ ...poloSLZ, ...polo }));
        } else {
          polos = cidade.polos.map(polo => {
            return polosEmCursos.find(poloEmCurso => polo.id === poloEmCurso.id);
          });
        }
        return { ...cidade, polos };
      });
  }

  private setSwitchTipoTurno(obj: any, campus: any) {
    let turnoIntegral = false;
    let turno;
    //console.log(campus.turno);
    /* Foi preciso fazer um if para buscar o turno */
    if(campus.turno.turno!=undefined){
      turno = campus.turno.turno;
    }else{
      turno = campus.turno;
    }
    switch (turno.trim().toUpperCase()) {
      case 'I':
        obj.integral = campus;
        turnoIntegral = true;
        break;
      case 'M':
        obj.matutino = campus;
        break;
      case 'V':
        obj.vespertino = campus;
        break;
      case 'N':
        obj.noturno = campus;
        break;
    }

    return turnoIntegral;
  }

  getTextoDesconto(campus: any) {
    return 'Bolsa-desconto de ' + campus.desconto + '%' +
      (campus.descontoPontualidade ? ' para pontualidade' : '') + ', conforme portaria ' + campus.portariaDesconto + '.';
  }

  closeModal() { }

  compareObjetoCursos(curso1, curso2) {
    return curso1 && curso2 && curso1.id === curso2.id;
  }

  compareObjetoCidades(cidade1, cidade2) {
    return cidade1 && cidade2 && cidade1.id === cidade2.id;
  }

  compararObjetosPorId(obj1, obj2) {
    return obj1 && obj2 && obj1.id === obj2.id;
  }

  reset() {
    this.curso = '';
    this.cidade = '';
    this.auxCampusTurno = {};
    this.campusTurno = undefined;
    this.polo = '';
  }

  capitalize(string) {
    //Se tiver algum CURSO SUPERIOR DE TECNOLOGIA EM, mudar para CST Em
    if(string.indexOf("CURSO SUPERIOR DE TECNOLOGIA")!=-1){
      //console.log('teste');
      string = string.replace("CURSO SUPERIOR DE TECNOLOGIA", "CST");
    }
    if(string.indexOf("-")!=-1){
      //console.log('teste');
      string = string.replace("-", " - ");
    }
    //console.log(string);
    if(string !== ''){
      let curso = '';
      string = string.split(' ');
      const proibidas = ['da', 'das', 'de', 'des', 'do', 'dos', 'e', 'em', 'cst', 'ead', 'rh', 'para'];

      string.forEach((palavra)=>{
        if (proibidas.indexOf(palavra.toLowerCase()) === -1) {
          curso = curso + ' ' +palavra.substr(0, 1).toUpperCase().concat(palavra.substr(1).toLowerCase());
          //console.log(curso);
        } else {
          //console.log(palavra);
          if(palavra!=='CST' && palavra!=='EAD') palavra = palavra.toLowerCase();
          if(palavra.toUpperCase()=='RH'){
            //console.log(string);
            palavra = 'Recursos Humanos';
          }
          curso = curso + ' ' + palavra;
        }
      })

      return curso;
    }
  }


  getMarketPlaceData(){
    this.marketPlaceData = JSON.parse(sessionStorage.getItem("marketPlaceData"));
  }

}
